export function IncludedBadge() {
  return (
    <div className="border-success/30 bg-success/10 text-success rounded-full border px-2 py-0.5 text-xs font-medium">
      Included
    </div>
  );
}
